class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.bindMinOrderGate();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-link');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  bindMinOrderGate() {
    if (typeof CartMinOrderGate === 'undefined') {
      document.addEventListener('DOMContentLoaded', () => this.bindMinOrderGate(), { once: true });
      return;
    }

    this.minOrderGate = CartMinOrderGate.bind({
      root: this,
      form: this.querySelector('#CartDrawer-Form'),
      checkoutSelector: '#CartDrawer-Checkout',
      modalId: 'CartDrawer-MinOrderModal',
      onAfterClose: () => this.restoreDrawerAfterModal(),
    });

    document.body.addEventListener('modalClosed', () => {
      if (this.classList.contains('active')) {
        this.restoreDrawerAfterModal();
      }
    });
  }

  restoreDrawerAfterModal() {
    if (!this.classList.contains('active')) return;
    document.body.classList.add('overflow-hidden');
    const container = document.getElementById('CartDrawer');
    const focusElement = this.querySelector('#CartDrawer-Checkout')
      || this.querySelector('.drawer__inner')
      || this.querySelector('.drawer__close');
    if (container) trapFocus(container, focusElement);
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.removeAttribute('hidden');
    const trapDrawerFocus = () => {
      const containerToTrapFocusOn = document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    };
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        trapDrawerFocus();
      }
    });

    this.addEventListener('transitionend', trapDrawerFocus, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    let renderedDrawer = false;

    this.getSectionsToRender().forEach((section) => {
      const html = parsedState.sections?.[section.id];
      if (!html) return;

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;

      const innerHTML = this.getSectionInnerHTML(html, section.selector);
      if (innerHTML === null) return;

      sectionElement.innerHTML = innerHTML;
      if (section.id === 'cart-drawer') renderedDrawer = true;
    });

    if (!renderedDrawer) {
      console.error('Cart drawer section did not render');
      return;
    }

    this.querySelector('.drawer__inner')?.classList.remove('is-empty');

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const node = parsed.querySelector(selector);
    if (!node) return null;

    return node.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    if (!html) return null;

    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
